import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import StockTable from "../../elements/Tables/StockTable/StockTable";
// import StockCreationForm from "../../elements/Forms/StockCreationForm/StockCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_STOCK_API,
  FETCH_ALL_COUNTER_API,
} from "../../../Constants/Apis";
import { Input, Select, message, Modal, Statistic } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteStock } from "../../../Services/StockService";

const { Search } = Input;

const StockPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
    current: 1,
    pageSize: 10,
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stockId, setStockId] = useState(null);

  // counter filter state
  const [counterFilter, setCounterFilter] = useState([]);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setStockId(id);
    setIsModalOpen(true);
  };

  const handleValidate = async () => {
    history.push("/user/validate-stock");
  };

  const handleOk = async () => {
    try {
      await deleteStock(stockId);
      message.success("Stock deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete stock."
      );
    }
    setIsModalOpen(false);
  };

  const stockApiUrl =
    userData?.counterCode === "ECOMMRI"
      ? `${FETCH_ALL_STOCK_API}/all/${userData.counterCode}`
      : `${FETCH_ALL_STOCK_API}`;

  const { fetchedData, callReFetch, loading } = useFetch(stockApiUrl, state);

  // extract table data + pagination
  const stockData = fetchedData?.data?.data || [];
  const paginationInfo = fetchedData?.data?.pagination || {
    current: 1,
    pageSize: 10,
    total: 0,
  };

  // ===== NEW: totals (from pagination) =====
  const totalItems = paginationInfo?.total ?? 0;
  // Prefer pagination.totalQuantity; fallback to data.totalQuantity if your API returns it there
  const totalQuantityAll =
    (paginationInfo && typeof paginationInfo.totalQuantity === "number"
      ? paginationInfo.totalQuantity
      : fetchedData?.data?.totalQuantity) ?? 0;

  // Also show current page total as extra info
  const totalQuantityThisPage = Array.isArray(stockData)
    ? stockData.reduce(
        (sum, row) => sum + (Number(row?.currentQuantity) || 0),
        0
      )
    : 0;
  // ========================================

  // fetch counters for filter options
  const { fetchedData: counterFetched = {} } = useFetch(
    FETCH_ALL_COUNTER_API,
    state
  );
  const counterData = counterFetched?.data || [];

  // handlers
  const handleSearch = (value) => {
    dispatch({ type: "current", payload: 1 });
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  const handlePaginationChange = (page, pageSize) => {
    dispatch({ type: "current", payload: page });
    dispatch({ type: "pageSize", payload: pageSize });
    callReFetch();
  };

  const handleCounterFilter = (value) => {
    setCounterFilter(value);
    dispatch({
      type: "filteredInfo",
      payload: {
        ...state.filteredInfo,
        counterCode: value && value.length > 0 ? value : undefined,
      },
    });
    dispatch({ type: "current", payload: 1 }); // reset page
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 12,
      }}
    >
      {/* ===== NEW: Summary bar (totals) ===== */}
      <div
        style={{
          width: "80vw",
          maxWidth: "100vw",
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            flex: "1 1 200px",
            background: "#fff",
            borderRadius: 12,
            padding: "12px 16px",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          }}
        >
          <Statistic title="Total Items" value={totalItems} />
        </div>
        <div
          style={{
            flex: "1 1 200px",
            background: "#fff",
            borderRadius: 12,
            padding: "12px 16px",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          }}
        >
          <Statistic title="Total Quantity (All)" value={totalQuantityAll} />
        </div>

      </div>
      {/* ===================================== */}

      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "80vw",
          maxWidth: "100vw",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <Select
          allowClear
          mode="multiple"
          style={{ minWidth: 220 }}
          placeholder="Filter by Counter Code"
          value={counterFilter}
          onChange={handleCounterFilter}
          maxTagCount={2}
          maxTagTextLength={12}
        >
          {counterData.map((c) => (
            <Select.Option key={c.code} value={c.code}>
              {c.code}
            </Select.Option>
          ))}
        </Select>

        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: 300 }}
        />
      </div>

      <StockTable
        history={history}
        loading={loading}
        data={stockData}
        pagination={paginationInfo}
        userData={userData}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
        onPaginationChange={handlePaginationChange}
      />

      <Modal
        title="Delete Stock"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this stock?</p>
      </Modal>
    </div>
  );
};

StockPage.propTypes = {
  history: PropTypes.object,
  userData: PropTypes.object,
};

export default StockPage;
